import PressStatements from "../../components/Home/PressStatements";
import RamadaanPlanner from "../../components/Home/RamadaanPlanner";
import FeaturedVideos from "../../components/Home/FeaturedVideos";
import UpcomingEvents from "../../components/Home/UpcomingEvents";
import HomeHeader from "../../components/Home/HomeHeader";
import Footer from "../../components/Footer/Footer";
import Khutbah from "../../components/Home/Khutbah";
import Intro from "../../components/Home/Intro";
import React from "react";
import "./Home.css";

const Home = () => {
  return (
    <div className="Home">
      <HomeHeader />
      <Intro />
      <PressStatements />
      <Khutbah />
      <RamadaanPlanner />
      <FeaturedVideos />
      <UpcomingEvents />
      <Footer />
    </div>
  );
};

export default Home;
